var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#DADBEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4001 4H14.0001C12.9392 4 11.9218 4.42143 11.1717 5.17157C10.4215 5.92172 10.0001 6.93913 10.0001 8V10.4H7.6001V13.6H10.0001V20H13.2001V13.6H15.6001L16.4001 10.4H13.2001V8C13.2001 7.78783 13.2844 7.58434 13.4344 7.43431C13.5844 7.28429 13.7879 7.2 14.0001 7.2H16.4001V4Z",
    stroke: "#424895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3616833de9651fedf89c12dcb8c822cd.svg";
export { ForwardRef as ReactComponent };